import { ComponentCO2Link } from '@acies/domain';
import { ObservableCollection } from '@acies/observables';

export default class ListComponentCO2LinkModel {
	public co2LinkCollection: ObservableCollection<ComponentCO2Link>;
	public loadingSpinnerVisible: boolean;
	public selectAllCheckBoxEnabled: boolean;
	public batchSpinnerVisible: boolean;
	public constructor() {
		this.co2LinkCollection = new ObservableCollection();
		this.loadingSpinnerVisible = false;
		this.selectAllCheckBoxEnabled = false;
		this.batchSpinnerVisible = false;
	}
}
